<script>import Tooltip from "../../Tooltip.svelte";
import Input from "../Input.svelte";
import { attrValue } from "../../../../utils/html";
import { colors } from "../../../../theme/colors";
export let props;
export let inputCenter = false;
let inputWidth;
let thumbWidth = props?.thumbWidth ?? 20;
let thumbHalfWidth = thumbWidth / 2;
let trackHeight = props?.trackHeight ?? 2;
let thumbColor = props?.thumbColor ?? "primary";
let trackColor = props?.trackColor ?? "secondary";
let leftDescription = props?.leftDescription;
let rightDescription = props?.rightDescription;
colors;
if (props) {
  props.min = props.min ?? 0;
  props.max = props.max ?? 1e4;
  props.step = props.step ?? 1;
  props.value = props.value ?? props.min;
}
const handleChange = () => {
  if (!props.touched) {
    props.touched = true;
  }
  if (!props.dirty) {
    props.dirty = true;
  }
};
$: tooltipPosition = inputWidth && (props.value - props.min) / (props.max - props.min) * (inputWidth - thumbHalfWidth - thumbHalfWidth) + thumbHalfWidth;
</script>

<Input bind:props>
	<div
		class={attrValue([
			'flex flex-col items-center relative',
			inputCenter ? 'justify-center w-full md:w-2/3 xl:w-2/3 mt-6' : ''
		])}
		bind:clientWidth={inputWidth}
	>
		<input
			id={props.id}
			type="range"
			step={props.step}
			name={props.name}
			min={props.min}
			max={props.max}
			bind:value={props.value}
			class="appearance-none w-full bg-{trackColor} rounded h-{trackHeight} rounded outline-none slider-thumb"
			style="--thumbWidth: {thumbWidth}px; --thumbColor: {colors[thumbColor]?.DEFAULT}; --thumbBorderColor: {colors[trackColor]?.DEFAULT}"
			on:change|once={() => handleChange()}
			disabled={props.disabled}
		/>
		{#if props && props.leftDescription && props.rightDescription}
			<div class="flex justify-between mt-3 w-full">
				<p class="text-sm">{props.leftDescription}</p>
				<p class="text-sm">{props.rightDescription}</p>
			</div>
		{/if}
		{#if props && !props.hideTooltip}
			<div
				class="absolute bottom-full transform -translate-x-1/2"
				style={`left:${tooltipPosition}px`}
			>
				{#if props.value}
					<Tooltip placement="top" title={props.value.toString()} fixedTooltipArrowPosition />
				{/if}
			</div>
		{/if}
	</div>
</Input>

<style>.slider-thumb::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background-color:var(--thumbColor);border:1px solid var(--thumbBorderColor);border-radius:9999px;cursor:pointer;height:var(--thumbWidth);width:var(--thumbWidth)}.slider-thumb::-moz-range-thumb{-moz-appearance:none;appearance:none;background-color:var(--color-primary);background-color:var(--thumbColor);border:1px solid var(--thumbBorderColor);border-radius:9999px;cursor:pointer;height:var(--thumbWidth);width:var(--thumbWidth)}.slider-thumb::-ms-thumb{appearance:none;background-color:var(--color-primary);background-color:var(--thumbColor);border:1px solid var(--thumbBorderColor);border-radius:9999px;cursor:pointer;height:var(--thumbWidth);width:var(--thumbWidth)}.slider-thumb::-moz-range-thumb:hover,.slider-thumb::-ms-thumb:hover,.slider-thumb::-webkit-slider-thumb:hover{opacity:.3}</style>
